/*
 * argile-share.js — bouton « copier le lien » des rangées de partage.
 *
 * Le bouton est rendu `hidden` par Liquid et n'est révélé qu'ici : sans presse-papier
 * disponible, un bouton visible mais inerte vaudrait moins que pas de bouton.
 * Les trois liens de réseaux n'ont besoin de rien et fonctionnent sans ce script.
 *
 * Délégation au document : la rangée est rendue à deux endroits de la page article
 * (hero et pied), et pourrait l'être ailleurs.
 */
(() => {
  const REVERT_MS = 2000;

  const reveal = () => {
    if (!navigator.clipboard && !navigator.share) return;
    document
      .querySelectorAll('[data-share-copy][hidden]')
      .forEach((b) => b.removeAttribute('hidden'));
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest && event.target.closest('[data-share-copy]');
    if (!btn) return;
    event.preventDefault();

    const url = btn.getAttribute('data-share-url') || window.location.href;

    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
      } else if (navigator.share) {
        await navigator.share({ url });
        return; // le partage natif a son propre retour visuel
      }
    } catch (e) {
      return; // refus utilisateur ou presse-papier indisponible : on ne signale rien de faux
    }

    // Retour VISIBLE : une bulle « Lien copié » au-dessus du bouton. `role="status"` sur
    // l'élément la fait aussi annoncer par les lecteurs d'écran — un seul mécanisme pour
    // les deux publics, plutôt qu'un aria-label qu'on échange et que personne ne voit.
    const copie = btn.getAttribute('data-copied-label');
    const toast = btn.parentElement && btn.parentElement.querySelector('[data-share-toast]');
    if (!copie || !toast) return;

    toast.textContent = copie;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => {
      toast.classList.remove('is-visible');
      // Vidé après la transition, sinon la bulle se réduit sur un texte encore présent.
      setTimeout(() => {
        if (!toast.classList.contains('is-visible')) toast.textContent = '';
      }, 200);
    }, REVERT_MS);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
